import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import fetch from '../../support/fetch';
import {Badge, Button, Card, Dimmer, Table, Text} from 'tabler-react';
import { badgeColor, statusDescription } from '../../support/subscription';
import './index.sass';
import './styleSpecial.css';

class SubscriptionsCard extends Component {

    state = {
        subscriptions: [],
        showLoading: true,
        isAnyActives: true,
    };

    fetchSubscriptions = () => {
        fetch.obj({
            query: `query FetchSubscriptions {
                subscriptions {
                    data {
                        id
                        status
                        status_color
                        payment_method
                        amount
                        created_at
                        plan {
                            name
                        }
                    }
                }
            }`
        })
        .then(res => {
            if (res.data.hasOwnProperty('subscriptions')) {
                console.log(res.data);
                let subscriptions = [];
                let isAnyActives = false;

                Object.keys(res.data.subscriptions.data).forEach((item, i) => {
                    subscriptions.push(this.content(i, res.data.subscriptions.data[item]));
                    if(res.data.subscriptions.data[item].status === "ACTIVATED"){
                        isAnyActives = true;
                    }
                });

                this.setState({
                    subscriptions: subscriptions,
                    showLoading: false,
                    isAnyActives: isAnyActives
                });
            }
        });
    };

    componentDidMount() {
        this.fetchSubscriptions();
        //console.log(this.state.subscriptions);
    }

    /**
     * Subscription row.
     *
     * @param i
     * @param subscription
     * @returns {XML}
     */
    content = (i, subscription) => {
        return (
            <Table.Row key={i}>
                <Table.Col className="text-nowrap">
                    <Text.Small>{subscription.created_at}</Text.Small>
                </Table.Col>
                <Table.Col className="text-nowrap">
                    <Badge color={badgeColor[subscription.status_color]}>
                        { statusDescription[subscription.status] }
                    </Badge>
                </Table.Col>
                <Table.Col className="text-nowrap">
                    <Text.Small>{subscription.plan.name}</Text.Small>
                </Table.Col>
                <Table.Col className="text-nowrap">
                    <Text.Small>{subscription.payment_method}</Text.Small>
                </Table.Col>
                <Table.Col className="text-nowrap">
                    <Text.Small>BRL {subscription.amount.toFixed(2)}</Text.Small>
                </Table.Col>
                <Table.Col>
                    <Link
                        to={'/subscriptions/' + subscription.id}
                        className="btn btn-secondary btn-sm">
                        ver detalhes
                    </Link>
                </Table.Col>
            </Table.Row>
        );
    };

    render() {
        return (
            <Card>
                <Card.Header className="pl-3">
                    <Card.Title>
                        <span className="m-0" style={{fontSize: '1.5rem',fontWeight: '600'}}>Minhas Assinaturas</span>
                    </Card.Title>
                    <div className='group-button-special '>
                        {
                            !this.state.isAnyActives &&
                            <Card.Options>
                                <a href="/subscriptions/free" className="btn btn-pill btn-primary a-distancing" style={{color: "white"}}>Migrar para o plano gratuito</a>
                            </Card.Options>

                        }
                         
                        <Card.Options>
                            <a href="/subscriptions/new" className="btn btn-pill btn-primary a-distancing" style={{color: "white"}}>Adicionar novo plano</a>
                        </Card.Options>
                        
                    </div>
                </Card.Header>
                <Dimmer loader active={this.state.showLoading} className="dimmer-table">
                    {
                        this.state.subscriptions.length > 0 &&
                        <Table cards responsive>
                            <Table.Header>
                                <Table.Row>
                                    <Table.ColHeader>Criação</Table.ColHeader>
                                    <Table.ColHeader>Status</Table.ColHeader>
                                    <Table.ColHeader>Plano</Table.ColHeader>
                                    <Table.ColHeader>Método</Table.ColHeader>
                                    <Table.ColHeader>Valor</Table.ColHeader>
                                    <Table.ColHeader/>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.subscriptions}
                            </Table.Body>
                        </Table>
                    }

                    {
                        this.state.subscriptions.length === 0 && <NoSubscriptionsYet />
                    }
                </Dimmer>
            </Card>
        );
    }
}

function NoSubscriptionsYet() {
    return (
        <div className="no-subscriptions">
            <p className='lead'>Você ainda não possui nenhuma assinatura vinculada à sua conta.</p>
            <p className='lead'>Gostaria de criar uma nova assinatura agora?</p>
            <a href='/subscriptions/new' className="btn btn-outline-info btn-lg">Sim, criar nova assinatura</a>
        </div>
    );
}

export default SubscriptionsCard
